export default __webpack_public_path__ + "static/media/shardex-logo.105a1542.svg";